import dayjs from "dayjs";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { IconCalendar } from "@pentabd/icons";
import { InputDate, Table } from "@pentabd/ui";

import { ButtonGroup } from "@components";
import { AttendanceTableColumn } from "./AttendanceTableColumn";

import { useAttendances } from "@hooks/HRM/attendances/useAttendances";
import { useMasterData } from "@hooks/useMasterData";

import { TablePagination } from "@helpers/tablePagination";

import { MASTER_DATA } from "@constants/master-data";

const { ATTENDANCE_STATUS } = MASTER_DATA;

interface AttendanceModalType {
  openMailModal: () => void;
}

const AttendanceTable = ({ openMailModal }: AttendanceModalType) => {
  const [activeStatus, setActiveStatus] = useState(0);
  const [selectedDate, setSelectedDate] = useState("");

  const { t } = useTranslation();
  const { data: attendanceStatus } = useMasterData(ATTENDANCE_STATUS);

  const { attendances, pagination, handleQuery } = useAttendances();
  const { total } = pagination || {};

  const modifiedData = attendances?.map((attendance: any) => ({
    employeeID: attendance.employee.id,
    attendanceID: attendance.attendance?.id,
    ...attendance.employee,
    ...attendance.attendance,
  }));

  const filterButtons = [
    t("ATTENDANCE.TABLE.BUTTONS.VIEW_BUTTON"),
    t("ATTENDANCE.TABLE.BUTTONS.PRESENT_BUTTON"),
    t("ATTENDANCE.TABLE.BUTTONS.ABSENT_BUTTON"),
  ];

  const findStatusId = (status: string) =>
    attendanceStatus.find((item: any) => item.nameEn === status)?.id;

  const btnGroupAction = (index: any) => {
    setActiveStatus(index);
    handleQuery(
      "attendanceStatusID",
      index === 1
        ? findStatusId("Present")
        : index === 2
        ? findStatusId("Absent")
        : "",
    );
  };

  return (
    <Table
      header={{
        title: t("ATTENDANCE.TABLE.LABEL"),
        badge: {
          label: `${total || 0}`,
          type: "primary",
        },
        // buttons: [<DateFilter />],
        buttons: [
          <InputDate
            portal
            name="date"
            defaultValue={dayjs(new Date()).format("YYYY-MM-DD")}
            prefix={<IconCalendar size="20" customFill="#667085" />}
            placeholder="Date"
            onSelectDate={(e) => {
              setSelectedDate(e);
              handleQuery("date", e);
            }}
          />,
        ],
      }}
      columns={AttendanceTableColumn(t, selectedDate, openMailModal)}
      rows={modifiedData}
      headerExtension={{
        leftComponents: [
          <ButtonGroup
            key="btn-group"
            btnGroupData={filterButtons}
            activeState={activeStatus}
            action={btnGroupAction}
          />,
        ],
      }}
      // actions={[
      //   {
      //     customIcon: <IconDownloadCloud02 fill="primary" size={24} />,
      //     onClick: () => console.log(),
      //   },
      //   {
      //     customIcon: <IconMail03 fill="primary" size={24} />,
      //     onClick: () => openMailModal(),
      //   },
      // ]}
      pagination={TablePagination(pagination, handleQuery)}
    />
  );
};

export default AttendanceTable;
